/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedClaimRouteImport } from './routes/_authed/claim'
import { Route as AuthedActivityRouteImport } from './routes/_authed/activity'
import { Route as AuthedAccountRouteImport } from './routes/_authed/account'
import { Route as AuthedDeviceIdRouteImport } from './routes/_authed/$deviceId'
import { Route as AuthedAccountIndexRouteImport } from './routes/_authed/account.index'
import { Route as AuthedAccountPasswordRouteImport } from './routes/_authed/account.password'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClaimRoute = AuthedClaimRouteImport.update({
  id: '/claim',
  path: '/claim',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedActivityRoute = AuthedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDeviceIdRoute = AuthedDeviceIdRouteImport.update({
  id: '/$deviceId',
  path: '/$deviceId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountIndexRoute = AuthedAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAccountRoute,
} as any)
const AuthedAccountPasswordRoute = AuthedAccountPasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => AuthedAccountRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/$deviceId': typeof AuthedDeviceIdRoute
  '/account': typeof AuthedAccountRouteWithChildren
  '/activity': typeof AuthedActivityRoute
  '/claim': typeof AuthedClaimRoute
  '/users': typeof AuthedUsersRoute
  '/login': typeof PublicLoginRoute
  '/account/password': typeof AuthedAccountPasswordRoute
  '/account/': typeof AuthedAccountIndexRoute
}
export interface FileRoutesByTo {
  '/$deviceId': typeof AuthedDeviceIdRoute
  '/activity': typeof AuthedActivityRoute
  '/claim': typeof AuthedClaimRoute
  '/users': typeof AuthedUsersRoute
  '/login': typeof PublicLoginRoute
  '/': typeof AuthedIndexRoute
  '/account/password': typeof AuthedAccountPasswordRoute
  '/account': typeof AuthedAccountIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/$deviceId': typeof AuthedDeviceIdRoute
  '/_authed/account': typeof AuthedAccountRouteWithChildren
  '/_authed/activity': typeof AuthedActivityRoute
  '/_authed/claim': typeof AuthedClaimRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/_public/login': typeof PublicLoginRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/account/password': typeof AuthedAccountPasswordRoute
  '/_authed/account/': typeof AuthedAccountIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$deviceId'
    | '/account'
    | '/activity'
    | '/claim'
    | '/users'
    | '/login'
    | '/account/password'
    | '/account/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$deviceId'
    | '/activity'
    | '/claim'
    | '/users'
    | '/login'
    | '/'
    | '/account/password'
    | '/account'
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/$deviceId'
    | '/_authed/account'
    | '/_authed/activity'
    | '/_authed/claim'
    | '/_authed/users'
    | '/_public/login'
    | '/_authed/'
    | '/_authed/account/password'
    | '/_authed/account/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicLoginRoute: typeof PublicLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/claim': {
      id: '/_authed/claim'
      path: '/claim'
      fullPath: '/claim'
      preLoaderRoute: typeof AuthedClaimRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/activity': {
      id: '/_authed/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthedActivityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$deviceId': {
      id: '/_authed/$deviceId'
      path: '/$deviceId'
      fullPath: '/$deviceId'
      preLoaderRoute: typeof AuthedDeviceIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/': {
      id: '/_authed/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthedAccountIndexRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
    '/_authed/account/password': {
      id: '/_authed/account/password'
      path: '/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof AuthedAccountPasswordRouteImport
      parentRoute: typeof AuthedAccountRoute
    }
  }
}

interface AuthedAccountRouteChildren {
  AuthedAccountPasswordRoute: typeof AuthedAccountPasswordRoute
  AuthedAccountIndexRoute: typeof AuthedAccountIndexRoute
}

const AuthedAccountRouteChildren: AuthedAccountRouteChildren = {
  AuthedAccountPasswordRoute: AuthedAccountPasswordRoute,
  AuthedAccountIndexRoute: AuthedAccountIndexRoute,
}

const AuthedAccountRouteWithChildren = AuthedAccountRoute._addFileChildren(
  AuthedAccountRouteChildren,
)

interface AuthedRouteChildren {
  AuthedDeviceIdRoute: typeof AuthedDeviceIdRoute
  AuthedAccountRoute: typeof AuthedAccountRouteWithChildren
  AuthedActivityRoute: typeof AuthedActivityRoute
  AuthedClaimRoute: typeof AuthedClaimRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedDeviceIdRoute: AuthedDeviceIdRoute,
  AuthedAccountRoute: AuthedAccountRouteWithChildren,
  AuthedActivityRoute: AuthedActivityRoute,
  AuthedClaimRoute: AuthedClaimRoute,
  AuthedUsersRoute: AuthedUsersRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicLoginRoute: PublicLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
